module.exports = __webpack_public_path__ + "static/smav-718c0f2eb4d7f76f70bccb12f15bd6e3.png";